// extracted by mini-css-extract-plugin
module.exports = {"Textarea":"Textarea_Textarea__h8bFu","small":"Textarea_small__6J0RR"};